"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const LogRocketCore = require("logrocket");
const state_1 = require("@airstudio/state");
class LogRocket extends state_1.Extensions.Abstract {
    constructor() {
        super();
        this.key = 'logrocket';
        this.selectors.set('sessionUrl', (state) => {
            return state.sessionURL || '';
        });
        state_1.Bus.onConfigReady(({ logrocket: { appId, props = {} } }) => {
            if (!appId) {
                // tslint:disable-next-line: no-console
                return console.warn('LogRocket extension is activated but backend config did not provide a `logrocket.appId` value');
            }
            LogRocketCore.init(appId, props);
            LogRocketCore.getSessionURL((sessionURL) => {
                this.dispatchSuccess({ sessionURL });
            });
        });
        state_1.Bus.onUserReady(({ userId }) => {
            LogRocketCore.identify(userId);
        });
    }
}
exports.LogRocket = LogRocket;
//# sourceMappingURL=index.js.map